<template>
    <Head>
        <title>Blockchain: Votes {{ network }} [{{ address }}]</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <div class="flex flex-col gap-8 p-8" v-if="result">
            <div class="flex flex-row gap-8 items-baseline">
                <Link class="text-blue-700 hover:text-blue-600" :href="route('blockchain.staking', [network, address])">&lt; Back</Link>
                <h1 class="text-2xl font-bold">Votes</h1>
            </div>
            <div class="grid grid-cols-2 gap-8">
                <div class="rounded bg-gray-100 p-4 flex flex-col gap-4">
                    <div class="flex flex-col gap-1">
                        <small class="text-gray-500">Address</small>
                        <span class="text-lg">{{ address }}</span>
                    </div>
                </div>
                <div class="rounded bg-gray-100 p-4 grid grid-cols-2 gap-4 divide-x">
                    <div class="flex flex-col items-center gap-1">
                        <small class="text-gray-500">Available Votes / Total Votes</small>
                        <span class="font-mono">{{ totalVotes - usedVotes }} / {{ totalVotes }}</span>
                    </div>
                    <div class="flex flex-col items-center gap-1">
                        <small class="text-gray-500">Claimable TRX Rewards</small>
                        <span class="font-mono">{{ claimableReward }}</span>
                        <v-button :disabled="claimableReward === '0'" color="blue" type="button" @click="claim">Claim</v-button>
                    </div>
                </div>
            </div>

            <div class="flex flex-col bg-white rounded p-4">
                <div class="flex flex-row justify-end">
                    <v-button type="button" :disabled="!changed" @click="vote">Vote</v-button>
                </div>
                <div class="grid grid-cols-7 p-2 gap-4 font-bold">
                    <span class="col-span-3">Address</span>
                    <span class="col-span-2">Name</span>
                    <span class="text-right" title="Процент годовых">APY</span>
                    <span title="Голоса">Votes</span>
                </div>
                <div class="grid grid-cols-7 border-t items-center p-2 gap-4"
                     v-if="result"
                     v-for="row of Object.values(result).filter(r => r.isActive).sort((a, b) => b.apy - a.apy)"
                >
                    <code class="col-span-3 text-gray-500 pt-2">{{ row.address }}</code>
                    <div class="col-span-2 flex flex-col gap-0">
                        <span>{{ row.name }}</span>
                        <small>{{ row.url }}</small>
                    </div>
                    <span class="font-mono text-right">{{ row.apy }}</span>
                    <v-input type="number" min="0" :max="totalVotes - usedVotes + row.votes" v-model="row.votes" @change="changed = true" />
                </div>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VInput, VSelect, VButton,
    },
    props: {
        address: String,
        network: String,
        result: Object,
        totalVotes: Number,
        claimableReward: String,
        notifications: Array,
    },
    data() {
        return {
            'changed': false,
            'claimVotingRewards': {
                'result': null,
                'errors': {},
            }
        }
    },
    computed: {
        usedVotes: (props) => Object.values(props.result).reduce((sum, r) => sum + parseInt(r.votes), 0),
    },
    methods: {
        vote() {
            const { changed, address, network, result } = this;

            if(!changed) return;
            this.changed = false;

            const data = Object.values(result)
                .filter(r => (r.votes > 0))
                .map(r => {
                    return { address: `${r.address}`, amount: `${r.votes}` };
                });

            axios.post(this.route('blockchain.staking.vote'), { address, network, data })
                .then(res => this.notifications.push(...res.data.notifications))
                .catch(err => {
                    this.changed = true;
                    this.notifications.push({ type: 'error', title: `Error ${err.response.status}`, message: err.response.data });
                });
        },
        claim() {
            const { address, network } = this;

            axios.post(this.route('blockchain.staking.claim-voting-rewards'), { address, network })
                .then(res => this.notifications.push(...res.data.notifications))
                .catch(err => this.notifications.push({ type: 'error', title: `Error ${err.response.status}`, message: err.response.data }));
        },
    },
};
</script>
